import React, {Component} from 'react';
import {connect} from 'react-redux';
import CartPropertyInlineSelection from "../configuration/CartPropertyInlineSelection";
import {querySelectCartProperty} from "../../actions/Properties";
import {getBillingPeriods} from "../../selectors/BillingPeriod";
import {getCartBillingPeriod} from "../../selectors/Cart";

function mapStateToProps(state) {
    return {
        billingPeriodInCart: getCartBillingPeriod(state),
        billingPeriods: getBillingPeriods(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {

        selectBillingPeriod: (value) => {
            return dispatch(querySelectCartProperty("billingPeriod", value));
        }
    };
}

class BillingPeriodGroup extends Component {
    render() {
        return (
            <div className={"custom-group custom-group--billingperiod"}>
                <h2>Anzahl der Rechnungen</h2>

                <p>Du kannst jeden Tarif monatlich kündigen. Um dir zusätzlichen Papierkram zu ersparen, kannst du außerdem bestimmen, wie oft du von uns eine Rechnung erhalten möchtest.</p>

                <CartPropertyInlineSelection
                    selectPropertyCallback={this.props.selectBillingPeriod}
                    propertyOptions={this.props.billingPeriods}
                    activeCartProperty={this.props.billingPeriodInCart}
                    selectionSuffix=""
                    inclusiveLabel=""
                    itemsPerRow={4}
                />
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillingPeriodGroup);


/** WEBPACK FOOTER **
 ** ./src/containers/configuration/BillingPeriodGroup.js
 **/